(function () {
  'use strict';

  angular
    .module('doubleSectorPriorToDayTurnaround')
    .controller('doubleSectorPriorToDayTurnaroundCtrl', doubleSectorPriorToDayTurnaroundCtrl);

  function doubleSectorPriorToDayTurnaroundCtrl(CommonMasterData, doubleSectorPriorToDayTurnaroundService ,MessageService, $compile,$scope,StorageServices,TabService,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'doubleSectorPriorToDayTurnaroundCtrl';

    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        autoOrManual : null,
        destinations: null,
      },
      masterList: {
        crewTypeList: [],
        destinationList: [],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        autoManualList : [{'autoOrManualCode':'M', 'autoOrManualDesc':'Manual'}, {'autoOrManualCode':'A', 'autoOrManualDesc':'Auto'}]

      },
      lastSearchDates:{
        fromDate:null,
        toDate:null
      },
      doubleSectorPriorToDayTurnaroundList: [],
      initialSearchDone: false
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    var dataObject = [];
    var hotSettings = [];
    var hot;

    vm.submitSearch = function (params) {
      doubleSectorPriorToDayTurnaroundService.searchDoubleSectorPriorToDayTurnaround(params,
        function (response) {
          vm.model.lastSearchDates.fromDate = vm.model.searchCriteria.fromDate;
          vm.model.lastSearchDates.toDate = vm.model.searchCriteria.toDate;
          vm.model.doubleSectorPriorToDayTurnaroundList = response.doubleSectorPriorToDayTurnaroundResponseDTOS;
          vm.model.searchPanelToggle = false;
          vm.model.totalNumberOfRecords = response.doubleSectorPriorToDayTurnaroundResponseDTOS.length;
          dataObject = vm.dataObject();
          hotSettings = vm.hotSettings();
          hot = new Handsontable(hotElement, hotSettings);
          $compile(hotElement)($scope);
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };

    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.doubleSectorPriorToDayTurnaroundList) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          CREW_NAME: vm.model.doubleSectorPriorToDayTurnaroundList[i].crewName,
          CREW_ID: vm.model.doubleSectorPriorToDayTurnaroundList[i].crewID,
          CREW_TYPE: vm.model.doubleSectorPriorToDayTurnaroundList[i].crewType,
          DOUBLE_SECTOR_START: vm.model.doubleSectorPriorToDayTurnaroundList[i].doubleSectorStart,
          DOUBLE_SECTOR_END: vm.model.doubleSectorPriorToDayTurnaroundList[i].doubleSectorEnd,
          LONG_FLIGHT_DESTINATION: vm.model.doubleSectorPriorToDayTurnaroundList[i].longFlightDestination,
          LONG_FLIGHT_DEPARTURE: vm.model.doubleSectorPriorToDayTurnaroundList[i].longFlightDeparture,
          AUTO: vm.model.doubleSectorPriorToDayTurnaroundList[i].autoOrManual,
        })
      }
      return dataObject;
    };

    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        manualColumnResize: true,
        copyRowsLimit: 1000000,
        colWidths: [vm.model.width * 0.05, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1],
        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true
          },
          {
            data: 'CREW_NAME',
            renderer: 'html',
            readOnly: true
          }, {
            data: 'CREW_ID',
            type: 'text',
            readOnly: true
          },  {
            data: 'CREW_TYPE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DOUBLE_SECTOR_START',
            type: 'text',
            readOnly: true
          },
          {
            data: 'DOUBLE_SECTOR_END',
            type: 'text',
            readOnly: true
          },
          {
            data: 'LONG_FLIGHT_DESTINATION',
            type: 'text',
            readOnly: true
          },
          {
            data: 'LONG_FLIGHT_DEPARTURE',
            type: 'text',
            readOnly: true
          },{
            data: 'AUTO',
            type: 'text',
            readOnly: true
          }],

        stretchH: 'all',
        width: vm.model.width * 0.99,
        autoWrapRow: true,
        height: vm.model.height * 0.7,
        rowHeaders: true,
        colHeaders: [
          '',
          'Crew Name',
          'Crew Id',
          'Crew Type',
          'Double Sector Start',
          'Double Sector End',
          'Long Flight Destination',
          'Long Flight Departure',
          'Auto/Manual'
        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');


    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }


    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;

        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

    };


    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    (function () {
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

    })();

    (function () {
      CommonMasterData.getAirportList(function (destinationList) {
        vm.model.masterList.destinationList = destinationList;
      }, function () {
        console.log('Airport list retrieval error');
      });

    })();
  }
}());
